/* eslint-disable no-useless-catch */
import * as fetchService from '../../../../sharedmodules/services/fetch';

const basePath = '/api';

const headerOptions = (accessToken) => ({
    Authorization: accessToken ? `Bearer ${accessToken}` : '',
});

export async function searchPinPlateRequests(getAccessToken, pinPlateRequest) {

    const endPoint = `${basePath}/admin/products/pin/plate/search`;
    const accessToken = await getAccessToken();

    const fetchOptions = {
        headers: {
            ...headerOptions(accessToken),
        },
        body: JSON.stringify(pinPlateRequest),
        method: 'POST',
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (error) {

        throw error;

    }

}
